// extracted by mini-css-extract-plugin
export var container = "_cc-0";
export var icon = "_cc-1";
export var text = "_cc-2";